var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('two-row-header'),_vm._v(" "),_c('main',{staticClass:"row page-member",attrs:{"id":"main","role":"main","aria-hidden":_vm.ariaHiddenMain}},[_c('member-side-nav',{staticClass:"columns small-12 medium-4"}),_vm._v(" "),_c('nuxt')],1),_vm._v(" "),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }